module.exports = __webpack_public_path__ + "static/media/33_CALCINHA_LATERAL_DRAPEADA_LISA_02.72b49386.jpg";